/**
 * SECURITY CONFIGURATION CONSTANTS
 *
 * Configuration constants for security features including rate limiting,
 * feature toggles, and environment-specific security settings.
 */

// RISK-BASED RATE LIMITER CONFIGURATIONS
export const RATE_LIMITERS = {
  // 🔴 CRITICAL OPERATIONS - Strictest limits
  CRITICAL_OPERATIONS: { maxRequests: 3, windowMs: 60000 }, // 3 per minute
  // - Account deletion, password changes, sensitive data modifications

  // 🟠 HIGH RISK OPERATIONS - Strict limits
  HIGH_RISK: { maxRequests: 5, windowMs: 60000 }, // 5 per minute
  // - Form submissions, tournament creation/updates, user profile changes

  // 🟡 MEDIUM RISK OPERATIONS - Moderate limits
  MEDIUM_RISK: { maxRequests: 15, windowMs: 60000 }, // 15 per minute
  // - Password validation, complex queries, data retrieval with parameters

  // 🟢 LOW RISK OPERATIONS - Lenient limits
  LOW_RISK: { maxRequests: 30, windowMs: 60000 }, // 30 per minute
  // - Simple data fetching, read-only operations

  // 📁 FILE OPERATIONS - Special handling
  FILE_UPLOADS: { maxRequests: 5, windowMs: 300000 }, // 5 per 5 minutes

  // 📊 ANALYTICS/BULK - Very permissive for UI performance
  BULK_READS: { maxRequests: 60, windowMs: 60000 }, // 60 per minute
  // - Dashboard data, statistics, bulk read operations
} as const;

// Backward compatibility aliases (to avoid breaking existing code)
export const LEGACY_RATE_LIMITERS = {
  FORM_SUBMISSION: RATE_LIMITERS.HIGH_RISK,
  API_CALLS: RATE_LIMITERS.MEDIUM_RISK,
  FILE_UPLOADS: RATE_LIMITERS.FILE_UPLOADS,
} as const;

// SECURITY FEATURE CONFIGURATION
export const SECURITY_CONFIG = {
  // Content Security Policy settings
  CSP_ENABLED: true,

  // Rate limiting enabled
  RATE_LIMITING_ENABLED: true,

  // Additional security features
  XSS_PROTECTION_ENABLED: true,
  CLICKJACKING_PROTECTION_ENABLED: true,

  // Environment-specific settings - production by default unless LOCAL_DEV=true
  STRICT_MODE: process.env.REACT_APP_LOCAL_DEV !== 'true',
} as const;
